import React from "react";
import NHP from "../images/NHPLogo.png";
import NRSC from "../images/ISRO_NRSC_Logo.png";
import { Grid, Menu, Header, Image } from "semantic-ui-react";
import bhuvan_logo from "../images/bhuvan_logo.png";
import bhuvan_logo_small from "../images/bhuvanLogo.png";
export default class HeaderCommon extends React.Component {
  render() {
    console.log(window.innerWidth)
    return (
      <Grid
        columns="equal"
        divided
        style={{ marginLeft: "0rem", marginRight: "-2rem" }}
      >
        <Grid.Row style={{ paddingTop: "1em", paddingBottom: "0em",marginBottom:window.innerWidth>1000?"8px":"2px" }} stretched>
          <Grid.Column>
            <Menu as={Header} attached style={{ backgroundColor: "#" }}>
              <Grid.Column floated="left">
                <Header as="h3">
                  <a
                    href="https://www.isro.gov.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    // target="_blank"
                  >
                    {" "}
                    <span className="full-text"> 
                    <img src={NRSC} height="64px"  />
                   </span>
                   <span className="short-text"> 
                     <img src={NRSC} height="45px" className="image_resize" /> 
                   </span>
                  </a>
                  {this.props.bhuvanlink ? (
                    <a
                      href="https://bhuvan-app1.nrsc.gov.in"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="full-text">
                        <img src={bhuvan_logo} height="64px" alt="bhuvan" />
                      </span>
                      <span className="short-text">
                        <img
                          src={bhuvan_logo_small}
                          height="45px"
                          alt="bhuvan"
                        />
                      </span>{" "}
                    </a>
                  ) : null}
                </Header>
              </Grid.Column>
              <Grid.Column>
                <Header as="h1" textAlign="center">
                  <Header.Content className="middle" >
                  {this.props.sub?
                  <span className="full-text-main" >  
                  {this.props.title1} </span>:null}
                  {this.props.sub?
                  <span className="full-text-main" >  
                  {this.props.title2} </span>:null}
                  {!this.props.sub? <div>
                  <span className="full-text-geo-main"  style={{fontSize: "20px"}}>  
                  {this.props.title1} </span>
                  <span className="short-text-geo-main" style={{fontSize: "10px"}}>
                  {this.props.screentitle1}
                  </span></div>:null}
                  {!this.props.sub? <div>
                  <span className="full-text-geo-main" style={{fontSize: "20px"}}>  
                  {this.props.title2} </span>
                  <span className="short-text-geo-main" style={{fontSize: "10px"}}>
                  {this.props.screentitle2}
                  </span></div>:null}
                    
                    {this.props.sub ? (
                      <div>
                      <Header.Subheader className="middle1">
                      <span className="sub-text-main">   National Remote Sensing Centre</span>
                      <span className="short-text-main">     National Remote Sensing Centre</span>
                     
                      </Header.Subheader>
                      <Header.Subheader className="middle1">
                      <span className="sub-text-main">   National Hydrology Project</span>
                      <span className="short-text-main">    National Hydrology Project</span>
                      {/* <span className="very-short-text">    NHP</span> */}
                      </Header.Subheader>
                      </div>
                    ) : null}
                  </Header.Content>
                </Header>
              </Grid.Column>
              <Grid.Column floated="right">
             
                <Header as="h3" textAlign="left">
                {/* <span className="full-text"> Version 1.0</span>
                <span className="short-text">V 1.0</span>
                <span className="very-short-text">1.0</span> */}
                  <a
                    href="http://nhp.mowr.gov.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    // target="_blank"
                  >
                    {" "}
                    <span className="full-text">
                    <img src={NHP} height="64px" />
                    </span>
                    <span className="short-text">
                    <img src={NHP} height="45px" />
                    </span>
                  </a>
                </Header>
              </Grid.Column>
            </Menu>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

